"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var currencySlice_1 = require("../../features/currencies/currencySlice");
var currencyConverter_1 = require("../../helpers/currencyConverter");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Price = function (_a) {
    var _b;
    var value = _a.value, defaultValue = _a.defaultValue, isDeveloper = _a.isDeveloper, className = _a.className;
    var hasPrice = !!((_b = value[0]) === null || _b === void 0 ? void 0 : _b.price);
    var rate = react_redux_1.useSelector(currencySlice_1.selectExchangeRate);
    var all = react_redux_1.useSelector(currencySlice_1.selectAllExchangeRates);
    var currency = react_redux_1.useSelector(currencySlice_1.selectCurrentCurrency);
    var convertedCurrency = hasPrice && currencyConverter_1.convertToCurrency(value, rate, all, currency);
    if (!hasPrice && !defaultValue) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.price, (isDeveloper || !hasPrice) && styles_module_scss_1.default.contractual, className) },
        hasPrice && react_1.default.createElement("i", { className: "icon-ic-" + currency }),
        hasPrice ? convertedCurrency : defaultValue));
};
exports.default = Price;
